export const SET_WHITE_LABEL_DATA = 'SET_WHITE_LABEL_DATA';

export function setWhiteLabelData(data) {
  return {
    type: SET_WHITE_LABEL_DATA,
    payload: data,
  };
}
